module.exports = __webpack_public_path__ + "98599e956610642dae55051afbc16e43.svg";